import styles from './DashBoard.module.css'
import MainFormTemplate from "../../FormTemplate/MainFormTemplate/MainFormTemplate";
import ErrorLineItem, {ErrorLineItemRef} from "../../FormTemplate/ErrorLineItem/ErrorLineItem";
import React, {useRef} from "react";
import useApiQuery from "../../ApiQuery/UseApiQuery";
import ActiveRecordItem from "../../FormTemplate/ActiveRecordItem/ActiveRecordItem";
import WaitLoader from "../../WaitLoader/WaitLoader";
import LoggerItem, {ILoggerItem} from "../../FormTemplate/LoggerItem/LoggerItem";
export default function DashBoard(){
    const errorLineRef = useRef<ErrorLineItemRef>(null)

    const reloadPayAgentData = useRef()
    const [ldrReloadPayAgent,rsReloadPayAgent,exReloadPayAgent] = useApiQuery("/dashboard/pay/agent/reload","post",reloadPayAgentData);


    const botUpdateData = useRef<{newPass:string}>()
    const [ldrBotUpdateData,rsBotUpdateData,exBotUpdateData] = useApiQuery("/bot/engine/restart","get",botUpdateData);


    const syncDbData = useRef()
    const [ldrSyncDb,rsSyncDb,exSyncDb] = useApiQuery("/dashboard/db/sync","post",syncDbData);
    const loggerRef = useRef<ILoggerItem>(null)

    const handleReloadPayAgent = ()=>{
        exReloadPayAgent().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef.current)errorLineRef.current.show("Агент перезагружен",false, 0)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true, 5000)
        })
    }
    const handleSyncDb = ()=>{
        exSyncDb().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef.current)errorLineRef.current.show("Базы синхронизированы",false, 0)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true, 5000)


        })
    }


    const handleBotUpdate = ()=>{
        exBotUpdateData().then((e)=>{
            if(e?.success)
            {
                if(errorLineRef.current)errorLineRef.current.show("Боты обновлены",false, 0)
                return
            }
            if(errorLineRef.current)errorLineRef.current.show(e?.errorAsString ? e?.errorAsString : "Ошибка сервера",true, 5000)


        })
    }

    return(
        <div className={styles.mainCont}>
            <MainFormTemplate title={"Панель управления"} maxWidth={"900px"}>
                <div className={styles.titleCont}>
                    <div className={styles.progTitle}>Прогресс операции : </div>
                    <WaitLoader loading={ldrReloadPayAgent || ldrSyncDb || ldrBotUpdateData } api={rsReloadPayAgent} onlyLoading={true}>

                    </WaitLoader>

                </div>
                <div className={"row"}>
                    <div className={"col-lg-4 col-sm-12"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>{
                                        handleReloadPayAgent()
                                    }}
                            >Перезапустить платежного агента</button>
                        </div>

                    </div>
                    <div className={"col-lg-4 col-sm-12"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>{
                                        handleSyncDb()
                                    }}
                            >Синхронизация баз данных</button>
                        </div>
                    </div>
                    <div className={"col-lg-4 col-sm-12"}>
                        <div className={styles.btnCont}>
                            <button type="button" className="btn btn-secondary "
                                    onClick={(e)=>{
                                        handleBotUpdate()
                                    }}
                            >Обновить ботов</button>
                        </div>
                    </div>

                </div>
                <div className={"row"}>
                    <div className={"col-sm-12 d-flex align-self-center"}>
                        <LoggerItem lineCount={10} ref={loggerRef} title={"Лог"}></LoggerItem>
                    </div>

                </div>


                <div className={styles.erCont}>
                    <ErrorLineItem ref={errorLineRef} ></ErrorLineItem>
                </div>
            </MainFormTemplate>
        </div>
    )
}